import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DynamicModule } from 'ng-dynamic-component';
import { StoryblokRichTextDirective } from 'src/app/directive/storyblok-richtext.directive';
import { StoryblokDirective } from 'src/app/directive/storyblok.directive';
import { FormComponent } from './form/form.component';

@Component({
  selector: 'app-contact-form',
  imports: [
    StoryblokRichTextDirective,
    RouterModule,
    DynamicModule,
    FormComponent,
  ],
  templateUrl: './contact-form.component.html',
  styleUrl: './contact-form.component.scss',
})
export class ContactFormComponent {
  @Input() title!: string;
  @Input() content!: any;
  @Input() contact_motivator!: string;
  @Input() background!: any;
  @Input() _editable: any;
  @Input() _uid!: string;
  @Input() component!: string;
}
